import { useQuery } from '@tanstack/react-query'
import { SHOP_QUERY_KEYS } from '@/modules/shop/constants'
import { ShopItemsService } from '@/modules/shop/api/services'
import type { paths } from '@/schema'

type ShopItemsQuery =
	paths['/api/admin/shop/items']['get']['parameters']['query']
type ShopItemsResponse =
	paths['/api/admin/shop/items']['get']['responses']['200']['content']['application/json']

const useQueryGetShopItems = (query?: ShopItemsQuery) => {
	return useQuery<ShopItemsResponse>({
		queryKey: SHOP_QUERY_KEYS.ITEMS.LIST(query),
		queryFn: () => ShopItemsService.getShopItems(query),
	})
}

export default useQueryGetShopItems
